/**
 * True when the user has not set a real chart name (empty, generic "Untitled", or legacy flow default).
 */
export function isBlankOrDefaultChartTitle(title) {
  const t = (title || "").trim();
  if (t.length === 0) return true;
  const lower = t.toLowerCase();
  return lower === "untitled" || lower === "untitled flow";
}
